// @ts-check
/**
 * Login Info API — the signed-in user's phone / login method / viewable password
 * (settings sheet → 登录信息). Backend: features/loginInfo.
 *
 * Response Types
 * @typedef {import('./types').MeLoginInfoResponse} MeLoginInfoResponse
 * @typedef {import('./types').MeLoginPasswordSetResponse} MeLoginPasswordSetResponse
 *
 * Request Types
 * @typedef {import('./types').MeLoginPasswordRequest} MeLoginPasswordRequest
 */

import { apiRequest } from './base';

/**
 * Phone number on the account, how the user logs in, and the password if it
 * was set through our screens (Authing never gives one back).
 * @returns {Promise<MeLoginInfoResponse>}
 */
export function getMyLoginInfo() {
  return apiRequest('/me/login-info');
}

/**
 * Set a new password (in Authing) and remember it so it can be looked up here.
 * @param {string} password - 6–20 letters/digits
 * @returns {Promise<MeLoginPasswordSetResponse>}
 */
export function setMyLoginPassword(password) {
  return apiRequest('/me/login-password', {
    method: 'POST',
    body: JSON.stringify({ password }),
  });
}
